export const areaOptions = (mode, t) => {
  if (mode === "solace") {
    return [
      {
        value: "stress-or-anxiety",
        label: t("HOME_AREA_STRESS_ANXIETY"),
      },
      {
        value: "depression",
        label: t("HOME_AREA_DEPRESSION"),
      },
      {
        value: "adhd-add",
        label: t("HOME_AREA_ADHD_ADD"),
      },
      {
        value: "fears-or-phobias",
        label: t("HOME_AREA_FEARS_OR_PHOBIAS"),
      },
      {
        value: "scholl-issues",
        label: t("HOME_AREA_SCHOLL_ISSUES"),
      },

      {
        value: "anger-issues",
        label: t("HOME_AREA_ANGER_ISSUES"),
      },
      {
        value: "relationship-with-friends",
        label: t("HOME_AREA_RELATIONSHIP_WITH_FRIENDS"),
      },

      {
        value: "eating-disorders",
        label: t("HOME_AREA_EATING_DISORDERS"),
      },
      {
        value: "sleeping-insomnia",
        label: t("HOME_AREA_SLEEPING_INSOMNIA"),
      },

      {
        value: "self-esteem",
        label: t("HOME_AREA_SELF_ESTEEM"),
      },
      {
        value: "personal-development",
        label: t("HOME_AREA_PERSONAL_DEVELOPMENT"),
      },
      {
        value: "lgbtq-issues",
        label: t("HOME_AREA_LGBTQ_ISSUES"),
      },

      {
        value: "other-specify",
        label: t("HOME_AREA_OTHER_SPECIFY"),
      },
    ]
  }

  return [
    {
      value: "stress-or-anxiety",
      label: t("HOME_AREA_STRESS_ANXIETY"),
    },
    {
      value: "career-progression",
      label: t("HOME_AREA_CAREER_PROGRESSION"),
    },
    {
      value: "interview-training",
      label: t("HOME_AREA_INTERVIEW_TRAINING"),
    },
    {
      value: "scholl-issues",
      label: t("HOME_AREA_SCHOLL_ISSUES"),
    },
    {
      value: "sports",
      label: t("HOME_AREA_SPORTS"),
    },
    {
      value: "personal-development",
      label: t("HOME_AREA_PERSONAL_DEVELOPMENT"),
    },

    {
      value: "other-specify",
      label: t("HOME_AREA_OTHER_SPECIFY"),
    },
  ]
}

export const approachOptions = (t) => [
  {
    value: "casual-conversation",
    label: t("HOME_APPROACH_CASUAL_CONVERSATION"),
  },
  {
    value: "deep-analytical",
    label: t("HOME_APPROACH_DEEP_ANALYTICAL"),
  },
]

export const typeOptions = (t) => [
  {
    value: "anonymous",
    label: t("HOME_ANONYMOUS"),
    tooltip: t("HOME_ANONYMOUS_TOOLTIP"),
  },
  {
    value: "classic",
    label: t("HOME_PROGRESSIVE"),
    tooltip: t("HOME_PROGRESSIVE_TOOLTIP"),
  },
]

export const stepNames = (t) => [
  t("HOME_PERSONALIZING_YOUR_JOURNEY"),
  t("HOME_GETTING_TO_KNOW_YOU"),
]

export const durationOptions = (approach, t) =>
  [
    approach !== "deep-analytical" && {
      value: "10-min",
      label: t("HOME_DURATION_10_MIN"),
    },
    {
      value: "15-min",
      label: t("HOME_DURATION_15_MIN"),
    },
    approach !== "casual-conversation" && {
      value: "20-min",
      label: t("HOME_DURATION_20_MIN"),
    },
  ].filter(Boolean)
